import React, { FC } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Grid } from "@mui/material";

import { DateInput, GridLineBreak, TextInput } from "@/components/atoms";
import {
    amoutMinMax,
    nameMaxLength,
} from "@/components/features/ToDos/DataVerification/Company/steps/GeneralStep/formSchema";
import { RefSelectInput } from "@/components/molecules";
import { StepComponentProps } from "@/components/organisms";
import { StyledHeaderTitleBase } from "@/styles/components";

import { CompanyFormType } from "../../formType";

const GeneralStep: FC<StepComponentProps> = () => {
    const { t } = useTranslation();

    const { control } = useFormContext<CompanyFormType>();

    return (
        <>
            <StyledHeaderTitleBase>{t("Common.General")}</StyledHeaderTitleBase>
            <Grid container marginTop={1} marginBottom={2}>
                <Grid item sm={8} xs={12}>
                    <TextInput
                        name="general.name"
                        label={t("Common.Name")}
                        required
                        control={control}
                        InputProps={{ inputProps: { maxLength: nameMaxLength } }}
                    />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <DateInput name="general.foundationDate" control={control} label={t("Common.FoundationDate")} />
                </Grid>
                <Grid item xs={12}>
                    <RefSelectInput
                        name="general.legalForm"
                        required
                        label={t("Common.LegalForm")}
                        table="legalStatus"
                        control={control}
                    />
                </Grid>
                <Grid item sm={4} xs={6}>
                    <DateInput
                        name="general.lastStatuteChangeDate"
                        control={control}
                        label={t("Common.LastUpdatedDate")}
                    />
                </Grid>
                <GridLineBreak />
                <Grid item sm={4} xs={6}>
                    <RefSelectInput name="general.language" required table="language" control={control} />
                </Grid>
                <Grid item sm={4} xs={6}>
                    <RefSelectInput name="general.nationality" required table="nationality" control={control} />
                </Grid>
                <GridLineBreak />
                <Grid item sm={4} xs={12}>
                    <TextInput name="general.enterpriseNumber" label={t("Common.EnterpriseNumber")} control={control} />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <TextInput
                        name="general.establishmentNumber"
                        label={t("Common.EstablishmentNumber")}
                        control={control}
                    />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <TextInput
                        name="general.nssoRegistrationNumber"
                        label={t("Common.RSZRegistrationNumber")}
                        control={control}
                    />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <TextInput
                        name="general.amountOfStaff"
                        type="number"
                        InputProps={{
                            inputProps: amoutMinMax,
                        }}
                        label={t("Common.NumberOfEmployees")}
                        control={control}
                    />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <TextInput
                        name="general.amountOfEmployees"
                        type="number"
                        InputProps={{
                            inputProps: amoutMinMax,
                        }}
                        label={t("Common.NumberOfClerks")}
                        control={control}
                    />
                </Grid>
                <Grid item sm={4} xs={12}>
                    <TextInput
                        name="general.amountOfWorkers"
                        type="number"
                        InputProps={{
                            inputProps: amoutMinMax,
                        }}
                        label={t("Common.NumberOfLabourers")}
                        control={control}
                    />
                </Grid>
            </Grid>
        </>
    );
};

export default GeneralStep;
